// @ts-nocheck
class WIprodesreadmore extends HTMLElement {
 constructor() {
    super();   
 }

 connectedCallback() {
    this.readMore();
  
 }

 // open read more 
    readMore() {
        let readMoreBtn = this.querySelector('.WI_accor_para_des_open');
        let fullPara = this.querySelector('.WI_accor_para_des_fullpara');
        readMoreBtn?.addEventListener('click', (e)=>{
            fullPara.style.maxHeight = fullPara.scrollHeight + "px";
            readMoreBtn.style.display = "none";
            let readMoreAccor = e.target.closest('.WI_accor_para');
            readMoreAccor.style.maxHeight = readMoreAccor.scrollHeight + "px";
            
        });
    }

 // open read more 
    readLess() {

    }

}
customElements.define("wi-prodes-readmore",WIprodesreadmore);